import { ResourceStore } from "@bryntum/schedulerpro";
import { Resource } from "../models/Resource";
import { SwivuSortedGroupersMixin } from "./mixins/SwivuSortedGroupersMixin";
import { SwivuStoreArchiveMixin } from "./mixins/SwivuStoreArchiveMixin";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

export class SwivuResourceStore extends SwivuSortedGroupersMixin(SwivuStoreArchiveMixin(ResourceStore)) {
  static get $name() {
    return "SwivuResourceStore";
  }

  static get configurable() {
    return {
      id: STORE_KEYS.resourceStore,
      storeId: STORE_KEYS.resourceStore,
      modelClass: Resource,
    };
  }
}
